import "../.././styles/Constitution.css";

function ArticleNine() {
    return(
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE IX: FINANCES AND REPORTS</h3>
                    <h5>9.1 Finances and Reports</h5>
                    <ol type="a">
                        <li><p>
                            <b>BANK ACCOUNT – </b>The Governing Board must open a bank account in the name of the
                            corporation, necessary to manage the day-to-day monetary transactions of the corporation.
                        </p></li>
                        <li><p>
                            <b>SIGNING – </b>Cheques and other documents requiring two signatures on behalf of the
                            corporation shall be signed by the President and either the Vice President or Treasurer.
                        </p></li>
                        <li><p>
                            <b>BOOKS OF ACCOUNTS &amp;RECORDS - </b>The Board shall keep true and complete accounts of all
                            funds received and disbursed by the Corporation and of all assets and liabilities of the
                            Corporation. All records kept by the Recording &amp; Communications Secretary and by the
                            Treasurer shall be audited by a duly qualified &amp; independent auditor appointed by the
                            Governing Board for that purpose.
                        </p></li>
                        <li><p>
                            <b>FINANCIAL YEAR-END – </b>The financial year-end of the corporation shall be the end of March
                            of every year.
                        </p></li>
                        <li><p>
                            <b>FINANCIAL REPORT – </b>The Governing Board must ensure that proper records and books of
                            accounts which fairly reflect the affairs of the corporation are kept current and reported
                            monthly, quarterly, and at the end of the fiscal year.
                        </p></li>
                        <li><p>
                            <b>INDEPENDENT AUDITOR - </b>The remuneration of the independent auditor for the
                            Corporation shall be determined by the Governing Board.
                        </p></li>
                        <li><p>
                            <b>INSPECTION OF BOOKS &amp; RECORDS – </b>The books of accounts, financial statements, and
                            related financial reports may be inspected by any voting and member in good standing at
                            the administration office during normal business hours, or as arranged with the auditor of
                            the corporation.
                        </p></li>
                    </ol>
                </div>
            </div>
    );
}

export default ArticleNine;